import { cdnUrl } from '@/constants';
import i18n from '@/localisation/i18n';
import { useUserStore } from '@/store/user';
import { useMutation } from '@tanstack/react-query';
import { deleteAvatar } from '../api/deleteAvatar';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export const ImageControls = () => {
  const { img, removeImage } = useUserStore();

  const { mutate, isPending } = useMutation({
    mutationFn: () => deleteAvatar(),
    onSuccess: removeImage,
  });

  if (!img) return null;

  return (
    <div className="mr-3 flex items-center justify-between">
      <div className="avatar relative mr-2">
        <div className="w-12 rounded-full">
          <LazyLoadImage
            width={48}
            height={48}
            effect="opacity"
            src={`${cdnUrl}/psychologists/${img}`}
            alt="Selected"
          />
        </div>
      </div>
      <button
        disabled={isPending}
        onClick={() => mutate()}
        className="btn btn-xs border-none bg-transparent hover:bg-transparent"
      >
        {i18n.t('delete')}
      </button>
    </div>
  );
};
